/* eslint-disable camelcase */
import React, { useState } from 'react';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import useCioBrowseAndGqlProducts from '../../hooks/useCioBrowseAndGqlProducts';
import {
  isFacetOptionSelected,
  updateFiltersInUrlParams,
} from '../../utils/filters';

const DesktopGridColorFilter = ({ display_name, options, name }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { selectedUrlFilters } = useCioBrowseAndGqlProducts();
  const router = useRouter();

  const handleOnChange = ({ facetName, facetOption }) => {
    updateFiltersInUrlParams({
      facetName,
      facetOption,
      router,
    });
  };

  return (
    <div>
      <button
        type="button"
        className="flex justify-between items-center border-0 w-full py-[12px] px-[8px]"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h2>{display_name}</h2>
        <p className="border-0 px-[8px] text-[18px]">
          {isExpanded ? '-' : '+'}
        </p>
      </button>
      {isExpanded && (
        <div className="grid grid-cols-2 gap-2 ml-[16px] my-[8px]">
          {options.map((option) => {
            return (
              <div key={option.value} className="flex gap-2">
                <input
                  type="checkbox"
                  id={`${name}-${option.value}`}
                  name={option.value}
                  onChange={() =>
                    handleOnChange({
                      facetName: name,
                      facetOption: option.value,
                    })
                  }
                  checked={isFacetOptionSelected({
                    facetName: name,
                    facetOption: option.value,
                    selectedUrlFilters,
                  })}
                />
                <label htmlFor={`${name}-${option.value}`}>
                  {option.display_name}
                </label>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

DesktopGridColorFilter.propTypes = {
  display_name: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      display_name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default DesktopGridColorFilter;
